import ActivityLog from '@components/activityLog/ActivityLog'
import { selectSelectedCluster } from '@store/ClusterReducer'
import { useAppSelector } from '@store/hooks'
import { Spin } from 'antd'

const View = () => {
  const item = useAppSelector(selectSelectedCluster())

  if (!item) {
    return <Spin />
  }

  return (
    <ActivityLog.Timeline
      entity="cluster"
      entityId={item.id}
      cardProps={{
        style: { maxHeight: 500, overflow: 'scroll', padding: 10 },
      }}
    />
  )
}

export default View
